import { render, staticRenderFns } from "./Mpago.vue?vue&type=template&id=15dfc72a&"
import script from "./Mpago.vue?vue&type=script&lang=js&"
export * from "./Mpago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports